import React from 'react';
import { Field } from 'redux-form';
import { renderTextField, renderNumberField, renderCurrencyField, requiredValidator, renderDatePicker, renderSelect } from 'utils/formHelper';

export default class LoanDetails extends React.Component {
  render = () => {
    return (
      <div>
        <Field
          name='amount'
          component={renderCurrencyField}
          label='Amount'
          normalize={(v) => v.replace(/\$|\,/g, '')}
          validate={requiredValidator}
        />
        <Field
          name='termLength'
          component={renderNumberField}
          label='Term Duration'
          validate={requiredValidator}
        />
        <Field
          name='termUnit'
          options={['month', 'week']}
          component={renderSelect}
          label='Term Unit'
          validate={requiredValidator}
        />
        <Field
          name='frequency'
          component={renderSelect}
          label='Repayment Frequency'
          options={['week', 'month']}
          validate={requiredValidator}
        />
        <Field
          name='drawdownDate'
          component={renderDatePicker}
          label='Drawdown Date'
          validate={requiredValidator}
        />
        <Field
          name='purpose'
          options={['Hire Staff', 'Working Capital', 'Marketing Campaign', 'Expand Premises', 'GST Payment', 'Payroll Tax Payment', 'Tax Payment', 'Purchase Equipment', 'Debt Consolidation', 'Payment of Existing Arrears', 'Other']}
          component={renderSelect}
          label="What's the loan for"
          validate={requiredValidator}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Leads/LoanDetails.js